"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const IMAGE_BASE = "/image/new-version/casting/Low-Pressure-Die-Casting/Applications";

const CATEGORIES = [
	{ keyPrefix: "applicationsCat1" },
	{ keyPrefix: "applicationsCat2" },
	{ keyPrefix: "applicationsCat3" },
	{ keyPrefix: "applicationsCat4" },
	{ keyPrefix: "applicationsCat5" },
] as const;

const IMAGES = [
	{
		src: `${IMAGE_BASE}/low-pressure-die-casting-parts-2.webp`,
		altKey: "applicationsImage2Alt",
		span: "lg:col-span-2",
		aspect: "aspect-[16/9]",
	},
	{
		src: `${IMAGE_BASE}/low-pressure-die-casting-parts-1.webp`,
		altKey: "applicationsImage1Alt",
		span: "",
		aspect: "aspect-[4/3]",
	},
	{
		src: `${IMAGE_BASE}/low-pressure-die-casting-parts-3.webp`,
		altKey: "applicationsImage3Alt",
		span: "",
		aspect: "aspect-[4/3]",
	},
] as const;

export default function Applications() {
	const t = useTranslations("new-low-pressure-casting");

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-10">
					<div>
						<h2 className="mb-4 text-2xl font-bold leading-tight text-black sm:mb-5 sm:text-[30px] md:text-4xl">
							{t("applicationsTitle")}
						</h2>
						<p className="mb-6 text-sm leading-relaxed text-black sm:mb-8 md:mb-10 md:text-base">
							{t("applicationsDesc")}
						</p>
						<div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
							{CATEGORIES.map((cat, i) => (
								<div
									key={cat.keyPrefix}
									className={i === CATEGORIES.length - 1 ? "sm:col-span-2" : undefined}
								>
									<h3 className="mb-2 flex items-center gap-2 text-base font-bold text-themePrimary400 sm:text-lg">
										<span className="inline-block h-4 w-[3px] bg-themePrimary400" aria-hidden />
										{t(`${cat.keyPrefix}Title` as any)}
									</h3>
									<p className="text-sm leading-relaxed text-black md:text-base">
										{t(`${cat.keyPrefix}Desc` as any)}
									</p>
								</div>
							))}
						</div>
					</div>

					<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5">
						{IMAGES.map((img) => (
							<div
								key={img.src}
								className={`relative ${img.aspect} ${img.span} overflow-hidden rounded-lg bg-[#ededed]`}
							>
								<Image
									src={img.src}
									alt={t(img.altKey as any)}
									fill
									className="object-contain"
									sizes="(max-width: 1024px) 100vw, 50vw"
								/>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
